import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AppService } from "../services/app.service";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class ReportGuard  {
  constructor(
    private appService: AppService) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.appService.getAvailableReports().pipe(map(accessibleReports => accessibleReports.filter(x => x.label == route.data.ReportName).length > 0
    ));
  }
}
